<template>
  <div style="width: 260px; height: 260px; margin: 0 auto;" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './resize'
var colorList = [
  '#30c7c9', '#b6a2de', '#59b1ef', '#ffb980',
  '#d87980', '#8c98b3', '#e5ce2c', '#97b552',
  '#996666', '#cc6699', '#339999', '#9966cc',
  '#6699cc', '#ff9933', '#cc6666', '#666699'
]
export default {
  mixins: [resize],
  props: {
    seriesData: {
      type: Array,
      default: () => []
    },
    machineNum: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      chart: null,
      legendData: []
    }
  },
  watch: {
    seriesData: {
      handler(newValue, oldValue) {
        this.seriesData = newValue // 把新值赋值给我们的属性数据
        this.seriesData.forEach((v) => {
          // if (v.name)v.name = (v.name).toUpperCase()
          this.legendData.push(v.name)
        })
        this.initChart() // 刷新echarts图表
      },
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
    })
    setTimeout(() => {
      this.initChart()
    }, 500)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      var option = {
        title: {
          text: this.machineNum,
          // subtext: '所有设备',
          subtext: this.$t('dashboard.Total'),
          x: 'center',
          y: 'center',
          textStyle: {
            fontSize: 30,
            fontWeight: 'normal',
            color: ['#333']
          },
          subtextStyle: {
            color: '#666',
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b} : {c} ({d}%)'
          formatter: '{b} : {c} ({d}%)'
          // formatter: (b) => {
          //   const m = thousandFn(b.value) || 0
          //   return b.name + ': ' + m + '(' + b.percent + '%)'
          // }
        },
        grid: {
          bottom: 150,
          left: 0,
          right: '10%'
        },
        legend: {
          show: false,
          orient: 'vertical',
          top: 'middle',
          right: '5%',
          textStyle: {
            color: '#f2f2f2',
            fontSize: 25

          },
          icon: 'roundRect'
        },
        series: [
        // 主要展示层的
          {
            radius: ['45%', '85%'],
            center: ['50%', '50%'],
            type: 'pie',
            itemStyle: {
              normal: {
                color: function(params) {
                  return colorList[params.dataIndex]
                },
                label: {
                  show: false// 去掉指示线和文字
                }
              }
            },
            labelLine: {
              normal: {
                show: true,
                length: 5,
                length2: 30,
                lineStyle: {
                  color: '#d3d3d3'
                },
                align: 'right'
              },
              color: '#000',
              emphasis: {
                show: true
              }
            },
            label: {
              normal: {
                formatter: function(params) {
                  var str = params.name + ' : ' + params.value
                  return str
                }
              }
            },
            data: this.seriesData
          },
          // 边框的设置
          {
            radius: ['80%', '85%'],
            center: ['50%', '50%'],
            type: 'pie',
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            labelLine: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            animation: false,
            tooltip: {
              show: false
            },
            itemStyle: {
              normal: {
                color: 'rgba(250,250,250,0.5)'
              }
            },
            data: [{
              value: 1
            }]
          }
        ]
      }
      this.chart.setOption(option, true)
    }
  }
}
</script>
